import { render } from "./SetupChecks.vue?vue&type=template&id=76a7d481&scoped=true"
import script from "./SetupChecks.vue?vue&type=script&lang=js"
export * from "./SetupChecks.vue?vue&type=script&lang=js"

import "./SetupChecks.vue?vue&type=style&index=0&id=76a7d481&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a7d481"]])

export default __exports__